export default __webpack_public_path__ + "static/media/Dis_Payment.b5a0f6c4.svg";